import get from "lodash/get"
import axios from "axios"
import * as ActionTypes from "constants-lib/actionTypes"
import { urls } from "utils-lib/builds"
import URITemplate from "urijs/src/URITemplate"

export const fulfilledAC = (data) => ({
  type: ActionTypes.GUEST_BULK_PICKUP_PRICING_FULFILLED,
  payload: data,
})

export const pendingAC = () => ({
  type: ActionTypes.GUEST_BULK_PICKUP_PRICING_PENDING,
})

export const failedAC = (data) => ({
  type: ActionTypes.GUEST_BULK_PICKUP_PRICING_FAILED,
  payload: data,
})

/**
 * Calculates pricing for guest bulk pickup requests based on items and customer details.
 * @param {string} customerId - The unique identifier for the customer.
 * @param {string} language - The language preference for the pricing information.
 * @param {string} token - The authentication token for the API request.
 * @param {Array} items - The list of items for bulk pickup.
 * @param {string} [bulkPickupRequestId=null] - Optional request ID for an existing bulk pickup request.
 * @returns {Promise<Object>} A promise that resolves with the pricing data or rejects with an error object.
 */
export const guestBulkPickupPricing =
  (customerId, language, token, items, bulkPickupRequestId = null) =>
  async (dispatch, getState) => {
    const api = `GUEST_BULK_PICKUP_PRICING`
    const baseUrl = urls.url[api]
    dispatch(pendingAC())

    const config = {
      headers: {
        token,
      },
    }
    const state = getState()

    const template = URITemplate(`${baseUrl}`)
    const url = template.expand({
      customerId,
      lang: language,
    })
    const apiKey = get(urls, `apiKey.GUEST[${api}]`, ``)
    if (apiKey !== ``) {
      config.headers.apiKey = apiKey
    }
    const body = {
      items,
      eligibilityId: get(
        state,
        `customerSelections.cityBilledEligibility.eligibilityId`,
        ``,
      ),
    }

    if (bulkPickupRequestId) body.bulkPickupRequestId = bulkPickupRequestId

    try {
      const response = await axios.create(config).post(url, body)

      dispatch(fulfilledAC(response.data))
      return response.data
    } catch (error) {
      const errorCode = get(error, `response.status`, ``)
      const errorMsg = get(error, `response.data.errorMsg`, ``)
      const statusCode = get(error, `response.data.statusCode`, ``)
      dispatch(failedAC({ errorCode, errorMsg, statusCode }))
      return error
    }
  }
